import { Outlet } from "react-router-dom";

import { Navbar } from "@/widgets/Navbar";

const BaseLayout = () => (
  <div className="min-h-dvh">
    <Navbar />
    <main>
      <Outlet />
    </main>
  </div>
);

export default BaseLayout;
